import "core-js/modules/es.function.name.js";
import pdf from 'vue-pdf';
export default {
  metaInfo: {
    meta: [{
      name: 'viewport',
      content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes'
    }]
  },
  components: {
    pdf: pdf
  },
  data: function data() {
    return {
      pdfSrc: '',
      // pdf文件地址
      numPages: 0
    };
  },
  methods: {
    back: function back() {
      var _this = this;
      var timer = setTimeout(function () {
        _this.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  },
  created: function created() {
    var name = this.$route.query.name;
    if (name == 'All New MG5') {
      this.pdfSrc = './mg5.pdf';
      this.numPages = 7;
    } else if (name == 'New MG Extender DC') {
      this.pdfSrc = './mgdc.pdf';
      this.numPages = 9;
    } else if (name == 'New MG Extender GC') {
      this.pdfSrc = './mggc.pdf';
      this.numPages = 9;
    } else if (name == 'New MG EP Plus') {
      this.pdfSrc = './mgep.pdf';
      this.numPages = 5;
    }
    console.log(this.pdfSrc + ' ' + this.numPages);
  }
};